'use client';

import { ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';
import { useOptimizely, type VariantProps } from '@/main/lib/providers/OptimizelyProvider';
import { type ArticleHeaderVariants, articleHeader } from './ArticleHeader.styles';

interface BylineReadTimeProps extends ArticleHeaderVariants {
  readTime: number;
}

export const BylineReadTime = ({ readTime, layout }: BylineReadTimeProps) => {
  const { userFlags } = useOptimizely();
  const readTimeFlag = userFlags.readTime as VariantProps | undefined;
  const isReadTimeEnabled = readTimeFlag?.enabled ?? false;

  if (!(isReadTimeEnabled && readTime) || readTime <= 0) {
    return null;
  }

  return (
    <>
      <span className='w-px h-3 bg-neutral-300 dark:bg-neutral-600' />
      <span
        className={cn(articleHeader().articleDate({ layout }))}
        data-cy={ContentPlacement.ReadTime}
      >
        {readTime} min read
      </span>
    </>
  );
};
